// import { createStyles, makeStyles, Theme } from '@'
import { createStyles, Theme } from "@mui/material";
import {makeStyles} from '@mui/styles'

export const commonStyles: any = makeStyles(
    (theme: Theme) =>
        createStyles({
            root: {
                display: 'flex',
            },
            mainContainer: {
                boxSizing: 'border-box',
                width: '100%',
                margin: 'auto',
                padding: '2vw'
            },
            toolbar: {
                display: 'flex',
                alignItems: 'center',
                padding: theme.spacing(0, 1),
                // marginTop: theme.spacing(6),
                marginLeft: theme.spacing(2),
                marginRight: theme.spacing(2),
                marginBottom: theme.spacing(1),
                // necessary for content to be below app bar
                ...theme.mixins.toolbar,
            },
            filterBar: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
                padding: theme.spacing(0, 1),
                marginBottom: theme.spacing(1),
            },
            content: {
                flexGrow: 1,
                padding: theme.spacing(3),
                backgroundColor: '#FFFFFF',
                // backgroundColor: '#f7f9fb',
            },
            appBar: {
                position: 'fixed',
                top: 'auto',
                left: 0,
                height: 60,
                bottom: 0,
                right: 0,
                backgroundColor: 'white',
            },
            media: {
                height: 40,
                width: 160,
                // marginTop: theme.spacing(1),
                flexDirection: 'row-reverse',
                marginLeft: 'auto',
            },
            link: {
                color: '#FFFFFF',
                textDecoration: 'underline',
                '&:hover': {
                    cursor: 'pointer',
                },
            },
            standardLink: {
                color: '#000000',
                textDecoration: 'underline',
                '&:hover': {
                    cursor: 'pointer',
                },
            },
            tableHeader: {
                backgroundColor: '#343834',
            },
            tableCell: {
                color: '#FFFFFF !important',
            },
            tableBody: {
                backgroundColor: '#FFFFFF',
            },
            modalTable: {
                minWidth: 550,
            },
            selectedTableCell: {
                backgroundColor: '#C7C9C7',
            },
            dropdown: {
                width: 200,
            },
            search: {
                color: '#000000',
                width: 300,
                height: 48,
                marginLeft: theme.spacing(2),
            },
            department: {
                right: 0,
                width: 200,
            },
            success: {
                color: '#4caf50'
            },
            error: {
                color: '#ef5350'
            }
        }),
    { index: 1 }
)
